import { SelectTriggerSkeleton } from '@/components/core';
import { EmployeeSearchPicker, useEmployeesByUserIds } from '@/modules/shared/hr-lookups';

export interface EmployeePickerProps {
  value: string;
  onChange: (value: string) => void;
  /** Restrict the choice to one unit (heads of unit) and hide the current user, who cannot open their own dashboard. */
  departmentId?: string;
  excludeId?: string;
}

export const EmployeePicker = ({
  value,
  onChange,
  departmentId,
  excludeId,
}: EmployeePickerProps) => {
  const { byUserId, isLoading } = useEmployeesByUserIds(value ? [value] : []);

  // Opened with `?userId=`: the placeholder would show until the employee's name loads.
  if (value && isLoading) return <SelectTriggerSkeleton className="w-full sm:w-72" />;

  return (
    <div className="w-full sm:w-72">
      <EmployeeSearchPicker
        value={value}
        selectedLabel={byUserId.get(value)?.DisplayName}
        departmentId={departmentId}
        excludeIds={excludeId ? [excludeId] : []}
        onSelect={(employee) => onChange(employee.UserId)}
      />
    </div>
  );
};
